module.exports = __webpack_public_path__ + "static/media/lr.177182a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lr.svg
// module id = 176
// module chunks = 0